import { Injectable, inject } from '@angular/core';
import { SharepointConfigurationsState } from '../../states/sharepoint-configurations.state';
import { GetSharepointConfigurationsStateResult } from './get-sharepoint-configurations-state.result';

/**
 * GetSharepointConfigurationsState use case.
 * Provides read-only access to SharePoint configuration state for presentation layer.
 * This maintains Clean Architecture by preventing direct State injection in presentation.
 */
@Injectable({ providedIn: 'root' })
export class GetSharepointConfigurationsStateUseCase {
  private readonly _state = inject(SharepointConfigurationsState);

  public execute(): GetSharepointConfigurationsStateResult {
    return {
      sharepointConfiguration: this._state.sharepointConfiguration,
      loadingSharepointConfiguration: this._state.loadingSharepointConfiguration,
      savingSharepointConfiguration: this._state.savingSharepointConfiguration,
      errorSharepointConfiguration: this._state.errorSharepointConfiguration,
      hasSharepointConfiguration: this._state.hasSharepointConfiguration,
      isConfigured: this._state.isConfigured,
    };
  }
}
